import axios from "axios"

export default async function getCampaignProductDropdown({ id, search }) {
    return new Promise((resolve, reject) => {
        axios.get(`/campaign/api/admin/campaigns/${id}/get-product-list`, {
            params: {
                search,
            }
        })
        .then((response) => resolve(response.data))
        .catch((error) => {
            return reject(error.response.data)
        })
    })
}
